import { render, staticRenderFns } from "./ResourceRootComponent.vue?vue&type=template&id=e578ea88"
import script from "./ResourceRootComponent.vue?vue&type=script&lang=js"
export * from "./ResourceRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports